import { Component, Input, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MyConfigOrganization } from '../../../../models/myConfig';
import { BackOffice24StatesService } from '../state/back-office24-states.service';
import { BackOfficeService } from '../../../../services/backoffice.service';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';

interface TransactionData {
  transactions: {
    [date: string]: {
      checkOut: number;
      paid: number;
      reversed: number;
      external: number;
    };
  };
}

interface ProcessedTransactionData {
  labels: string[];
  datasets: {
    checkOut: number[];
    paid: number[];
    reversed: number[];
    external: number[];
  };
}

@Component({
  selector: 'app-finance',
  standalone: false,
  templateUrl: './finance.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './finance.component.css'
})
export class FinanceComponent implements OnInit, OnDestroy {
  @Input() organization: MyConfigOrganization;
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective<'line'>;

  public isLoading = false;
  public transactionLineChartData: ChartData<'line'> = { labels: [], datasets: [] };

  private destroy$ = new Subject<void>();
  private orgSubscription = new Subscription();
  private activeRequests = 0;
  private transactionData: TransactionData | null = null;

  public readonly transactionLineChartOptions: ChartConfiguration<'line'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    scales: {
      x: {
        title: { display: true, text: 'Date' },
        grid: {
          display: true,
          color: 'rgba(0,0,0,0.1)'
        }
      },
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Amount (SEK)' },
        ticks: {
          callback: function(value) {
            return new Intl.NumberFormat('sv-SE', {
              style: 'currency',
              currency: 'SEK',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value as number);
          }
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: 'top'
      },
      title: {
        display: true,
        text: 'Transaction Analytics',
        font: {
          size: 16,
          weight: 'bold'
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: (context) => {
            const value = new Intl.NumberFormat('sv-SE', {
              style: 'currency',
              currency: 'SEK'
            }).format(context.parsed.y);
            return `${context.dataset.label}: ${value}`;
          }
        }
      }
    }
  };

  constructor(
    private backOfficeService: BackOfficeService,
    private backOffice24StatesService: BackOffice24StatesService
  ) { }

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$
      .pipe(takeUntil(this.destroy$))
      .subscribe(org => this.organization = org);

    // this.loadAllData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.orgSubscription.unsubscribe();
  }

  // private loadAllData(): void {
  //   this.loadTransactionData();
  // }

  // private loadTransactionData(): void {
    // this.executeRequest(
    //   this.backOfficeService.getDashBoardTransactionData(),
    //   (data: TransactionData) => {
    //     console.log('loadTransactionData', data);
    //     this.transactionData = data;
    //     this.processTransactionData();
    //   }
    // );
  // }

  // private processTransactionData(): void {
  //   if (!this.transactionData?.transactions) return;

  //   const processed = this.processTransactions();
  //   this.transactionLineChartData = this.createTransactionChartData(processed);
  //   this.updateChart();
  // }

  // private processTransactions(): ProcessedTransactionData {
  //   const transactions = this.transactionData!.transactions;
  //   const sortedDates = Object.keys(transactions).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

  //   const labels = sortedDates.map(date => new Date(date).toLocaleDateString('en-US', {
  //     month: 'short',
  //     day: 'numeric'
  //   }));

  //   const datasets = {
  //     checkOut: sortedDates.map(date => transactions[date].checkOut),
  //     paid: sortedDates.map(date => transactions[date].paid),
  //     reversed: sortedDates.map(date => transactions[date].reversed),
  //     external: sortedDates.map(date => transactions[date].external)
  //   };

  //   return { labels, datasets };
  // }

  // private createTransactionChartData(data: ProcessedTransactionData): ChartData<'line'> {
  //   const colors = {
  //     checkOut: { border: 'rgb(54, 162, 235)', background: 'rgba(54, 162, 235, 0.2)' },
  //     paid: { border: 'rgb(75, 192, 192)', background: 'rgba(75, 192, 192, 0.2)' },
  //     reversed: { border: 'rgb(255, 99, 132)', background: 'rgba(255, 99, 132, 0.2)' },
  //     external: { border: 'rgb(255, 159, 64)', background: 'rgba(255, 159, 64, 0.2)' }
  //   };

  //   return {
  //     labels: data.labels,
  //     datasets: Object.entries(colors).map(([key, color]) => ({
  //       label: this.formatLabel(key),
  //       data: data.datasets[key as keyof typeof data.datasets],
  //       borderColor: color.border,
  //       backgroundColor: color.background,
  //       tension: 0.1
  //     }))
  //   };
  // }

  // private formatLabel(key: string): string {
  //   const labelMap: { [key: string]: string } = {
  //     checkOut: 'Check Out',
  //     paid: 'Paid',
  //     reversed: 'Reversed',
  //     external: 'External'
  //   };
  //   return labelMap[key] || key;
  // }

  // private updateChart(): void {
  //   this.chart?.update();
  // }

  // private executeRequest<T>(request: any, onSuccess: (data: T) => void): void {
  //   this.incrementRequests();
  //   request.pipe(takeUntil(this.destroy$))
  //     .subscribe({
  //       next: (data: T) => { onSuccess(data); this.decrementRequests(); },
  //       error: (error: any) => { console.error('API request failed:', error); this.decrementRequests(); }
  //     });
  // }

  // private generateColors(count: number) {
  //   const baseColors = [
  //     { background: 'rgba(54, 162, 235, 0.8)', border: 'rgba(54, 162, 235, 1)' },
  //     { background: 'rgba(255, 99, 132, 0.8)', border: 'rgba(255, 99, 132, 1)' },
  //     { background: 'rgba(75, 192, 192, 0.8)', border: 'rgba(75, 192, 192, 1)' },
  //     { background: 'rgba(255, 206, 86, 0.8)', border: 'rgba(255, 206, 86, 1)' },
  //     { background: 'rgba(153, 102, 255, 0.8)', border: 'rgba(153, 102, 255, 1)' },
  //     { background: 'rgba(255, 159, 64, 0.8)', border: 'rgba(255, 159, 64, 1)' },
  //     { background: 'rgba(199, 199, 199, 0.8)', border: 'rgba(199, 199, 199, 1)' },
  //     { background: 'rgba(83, 102, 255, 0.8)', border: 'rgba(83, 102, 255, 1)' },
  //     { background: 'rgba(255, 99, 255, 0.8)', border: 'rgba(255, 99, 255, 1)' },
  //     { background: 'rgba(99, 255, 132, 0.8)', border: 'rgba(99, 255, 132, 1)' },
  //     { background: 'rgba(255, 159, 132, 0.8)', border: 'rgba(255, 159, 132, 1)' }
  //   ];

  //   return Array.from({ length: count }, (_, i) =>
  //     baseColors[i % baseColors.length]
  //   );
  // }

  incrementRequests(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) this.isLoading = true;
  }

  decrementRequests(): void {
    if (this.activeRequests > 0) this.activeRequests--;
    if (this.activeRequests === 0) this.isLoading = false;
  }
}
